import * as React from "react";

import { Text } from "../../../components/atoms";
import { TextDoubleHeader } from "../../../components/molecules";
import { LoginRegistrationContainer } from "../../../containers/booking/login-registration";
import { Column, Container, Row } from "../../grid";

const LoginColumn = Column.extend`
  max-width: 500px;
`;

const Login: React.FC = () => {
  return (
    <Container limitedWidth offsetPaddings>
      <Row justifyContent="center">
        <LoginColumn>
          <TextDoubleHeader>
            <Text size="20" weight="bold" transform="uppercase">
              Login
            </Text>
          </TextDoubleHeader>
          <LoginRegistrationContainer
            loggedInRoute="/account"
            loggedOutRoute="/login"
          />
        </LoginColumn>
      </Row>
    </Container>
  );
};

export { Login };
